import { clientApi } from 'shared/api/clientApi'
import { refreshOrdersCount } from 'shared/api/orders-count-query'

import {
  ActiveOrderResponse,
  CancellationPenaltyResponse,
  CheckPersonalDataRequest,
  CheckPersonalDataResponse,
  CreateOrderRequest,
  CreateOrderResponse,
  DeclineOrderResponse,
  OrderDetailResponse,
  OrdersListRequest,
  OrdersListResponse,
} from './model'

export const KyrgyzstanOrdersApi = {
  checkPersonalData(data: CheckPersonalDataRequest) {
    return clientApi.post<CheckPersonalDataResponse>(
      '/kyrgyzstan/orders/check-personal-data',
      data,
    )
  },

  async createOrder(data: CreateOrderRequest) {
    const response = await clientApi.post<CreateOrderResponse>(
      '/kyrgyzstan/orders/',
      data,
    )
    void refreshOrdersCount()
    return response
  },

  getLastActiveOrder() {
    return clientApi.get<ActiveOrderResponse>('/kyrgyzstan/orders/active/last')
  },

  getOrdersList(params: OrdersListRequest, signal?: AbortSignal) {
    return clientApi.get<OrdersListResponse>('/kyrgyzstan/orders/', {
      params,
      signal,
    })
  },

  getOrderDetail(orderId: string) {
    return clientApi.get<OrderDetailResponse>(`/kyrgyzstan/orders/${orderId}`)
  },

  getCancellationPenalty(orderId: string, signal?: AbortSignal) {
    return clientApi.get<CancellationPenaltyResponse>(
      `/kyrgyzstan/orders/${orderId}/cancellation-penalty`,
      { signal },
    )
  },

  declineOrder(orderId: string) {
    return clientApi.patch<DeclineOrderResponse>(
      `/kyrgyzstan/orders/${orderId}/decline`,
    )
  },
}
